import React, { Component } from "react";
import { Row, Button, Col } from "react-bootstrap";
import { connect } from "react-redux";

import Dropdown from "../dropdown/components/Dropdown";
import PredictionBar from "./PredictionBars";
import WebCam from "../../../components/WebCam";
import FileDropZone from "../../../components/fileDropZone";
import ToggleSwitch from "../../asset_components/ToggleSwitch";

import deleteIcon from "../../../assets/icons/x.svg";
import webCamIcon from "../../../assets/icons/inferCamera.svg";
import uploadIcon from "../../../assets/icons/uploadIcon.svg";
import expModel from "../../../assets/expModel.svg";
import flipIcon from "../../../assets/mobileAssets/flipCam.svg";
import WebCamEnv from "../../mobileComponents/WebCamEnv";

class InferenceOn extends Component {
  divID = "1.0";
  localCamStatus = true;
  infImgSrc = null;
  constructor(props) {
    super(props);
    let webCamIconV = (
      <div>
        <Col xs={1} style={{ paddingLeft: "0px" }}>
          <img src={webCamIcon} />
        </Col>
        <Col
          xs={1}
          style={{ paddingLeft: "4px", paddingTop: "2px", fontSize: "12px" }}
        >
          webcam
        </Col>
      </div>
    );
    let uploadIconV = (
      <div>
        <Col xs={1} style={{ paddingLeft: "0px" }}>
          <img src={uploadIcon} />
        </Col>
        <Col
          xs={1}
          style={{ paddingLeft: "4px", paddingTop: "2px", fontSize: "12px" }}
        >
          upload
        </Col>
      </div>
    );
    this.state = {
      type: [
        {
          id: 0,
          title: webCamIconV,
          selected: false,
          key: "webcam",
        },
        {
          id: 1,
          title: uploadIconV,
          selected: false,
          key: "upload",
        },
      ],
      webCamStatus: true,
      typeSelected: "webcam",
      imgUploaded: false,
      facing: 1,
      localClassNArr: [],
      predsArr: [],
    };
  }

  switchStatusFromChild = (status) => {
    if (status) {
      this.localCamStatus = status;
      this.props.stopGlobalCam(status, this.divID);
    } else {
      this.localCamStatus = status;
      this.props.stopGlobalCam(status);
    }
  };

  reUpload = () => {
    this.setState({
      imgUploaded: false,
    });
  };

  async getFromChild(previewSrc) {
    this.infImgSrc = previewSrc;
    this.setState({
      imgUploaded: true,
    });
    const img = new Image();
    img.width = 224;
    img.height = 224;
    img.src = previewSrc;
    img.onload = async () => {
      await this.props.obj.infer_model(img).then(
        function (result) {
          this.props.sendPreds(result);
        }.bind(this)
      );
    }
  }

  resetThenSet = (id, key) => {
    if (key === "upload") {
      this.setState({
        typeSelected: key,
        //webCamStatus: false
      });
      this.localCamStatus = false;
      this.props.stopGlobalCam(false);
    } else {
      this.setState({
        typeSelected: key,
        //webCamStatus: true
      });
    }
  };

  componentDidMount() {
    this.props.stopGlobalCam(true, this.divID);
  }

  componentWillReceiveProps(nextProps) {
    if (this.divID !== nextProps.gclassID) {
      this.localCamStatus = false;
    }
    /* this.setState({
      predsArr: nextProps.gPredsArr,
      localClassNArr: nextProps.classNArr,
    }); */
  }

  switchCamFunc = () => {
    if (this.state.facing === 1) {
      this.setState({
        facing: 0,
      });
    } else {
      this.setState({
        facing: 1,
      });
    }
  };

  render() {
    let showInputType,
      tSwitch,
      expModelDiv,
      flipCam,
      mTop = "0px";
    if (this.props.deviceType === "DESKTOP") {
      mTop = "90px";
      expModelDiv = (
        <Button
          style={{
            padding: "0px",
            border: "0px",
            backgroundColor: "#2E3A53",
            marginLeft: "12px",
            outline: "none",
          }}
        >
          <img src={expModel} />
        </Button>
      );
    } else {
      mTop = "22px";
    }
    if (this.state.typeSelected === "webcam") {
      tSwitch = (
        <ToggleSwitch
          switchStatusPFunc={this.switchStatusFromChild.bind(this)}
          onOff={this.localCamStatus}
        />
      );
    } else if (this.state.imgUploaded) {
      tSwitch = null;
      showInputType = (
        <div style={{ position: "relative" }}>
          <img
            src={deleteIcon}
            alt="delete"
            style={{
              position: "absolute",
              marginLeft: "50%",
              zIndex: 2,
              marginTop: "13px",
            }}
            onClick={this.reUpload}
          />
          <img
            src={this.infImgSrc}
            style={{
              marginTop: "10px",
              borderRadius: "4px",
              width: "224px",
              height: "224px",
              objectFit: "cover",
            }}
          />
        </div>
      );
    } else {
      tSwitch = null;
      showInputType = (
        <FileDropZone dndCall={this.getFromChild.bind(this)} inf={true} />
      );
    }

    if (this.props.deviceType !== "DESKTOP" && this.localCamStatus) {
      flipCam = (
        <div
          style={{
            marginLeft: "290px",
            position: "absolute",
            zIndex: "1",
          }}
        >
          <img
            style={{ height: "20px", width: "20px" }}
            onClick={this.switchCamFunc}
            src={flipIcon}
          />
        </div>
      );
    }

    if (this.localCamStatus && this.state.facing) {
      showInputType = (
        <WebCam
          capture={false}
          obj={this.props.obj}
          deviceType={this.props.deviceType}
        />
      );
    } else if (this.localCamStatus && !this.state.facing) {
      showInputType = <WebCamEnv capture={false} obj={this.props.obj} />;
    } else if (this.state.typeSelected !== "upload") showInputType = null;

    return (
      <div
        id={this.divID}
        style={{
          marginTop: mTop,
          borderWidth: "1px",
          borderStyle: "solid",
          background: "#2E3A53",
          width: "385px",
          boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: "9px",
        }}
      >
        <Row>
          <div
            style={{ marginTop: "37px", marginLeft: "32px", width: "178px" }}
          >
            <Col xs={8}>
              <div
                style={{
                  height: "42px",
                  width: "62px",
                  color: "#C2C0BD",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                <p style={{ paddingTop: "10.5px" }}>Preview</p>
              </div>
            </Col>
            <Col xs={4}>
              <div>{expModelDiv}</div>
            </Col>
          </div>
        </Row>
        <Row>
          <div>
            <center>
              <p
                style={{
                  width: "325px",
                  height: "0px",
                  marginTop: "11px",
                  color: "#C2C0BD",
                  borderStyle: "solid",
                  borderWidth: "0.5px",
                }}
              />
            </center>
          </div>
        </Row>
        <Row>
          <div
            style={{ marginTop: "11px", width: "312px", marginLeft: "32px" }}
          >
            <Col xs={8}></Col>
            {tSwitch}
            <Col xs={4}>
              <div>
                <Dropdown
                  width={"100px"}
                  list={this.state.type}
                  default={this.state.type[0]["title"]}
                  resetThenSet={this.resetThenSet}
                  hbackgroud={"#2E3A53"}
                  bStyle={"0.5px solid #475A82"}
                  bRadius={"6px"}
                  padding={"4px"}
                  buttonType={"down_svg"}
                />
              </div>
            </Col>
          </div>
        </Row>
        <Row>
          <div>
            {flipCam}
            <center>{showInputType}</center>
          </div>
        </Row>
        <Row>
          <center>
            {this.props.classNArr.map((bars, index) => {
              //console.log(this.state.predsArr); //UNCOMMENT HERE TO SEE PREDICTION ARRAY
              return (
                <PredictionBar
                  className={bars}
                  preds={this.props.gPredsArr[index]}
                  key={index++ + "bar"}
                  id={index + "bar"}
                />
              );
            })}
          </center>
        </Row>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    //DISABLE CAM ON MOUNT
    stopGlobalCam: (gCam, classID) => {
      dispatch({
        type: "GLOBAL_CAM",
        gCam: gCam,
        classID: classID,
      });
    },
    //SEND PREDS TO STORE
    sendPreds: (preds) => {
      dispatch({
        type: "PREDICTION %",
        preds: preds,
      });
    },
  };
};

const mapStateToProps = (state) => {
  return {
    globalCam: state.globalCam,
    gclassID: state.gclassID,
    classNArr: state.classNArr,
    gPredsArr: state.gPredsArr,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InferenceOn);
